<div class="title-row">
    @if (!hideShowMore()) {
    <div class="show-more-icon" (click)="showMore()"></div>
    }
    <h3 class="title">{{ title() }}</h3>
</div>
